// extracted by mini-css-extract-plugin
export var actions = "bG_d3";
export var articleMultipleChoiceCTA = "bG_fc";
export var body = "bG_ff";
export var bodyContainer = "bG_fd";
export var illustration = "bG_fh";
export var selected = "bG_fl";
export var subtitle = "bG_fk";
export var textContent = "bG_fj";
export var tile = "bG_fg";
export var wrapper = "bG_bM";